/**
 * Convert a string or array of commands to an array of commands.
 *
 * @param urlOrCommands
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toCommand = (urlOrCommands: string | any[]) =>
    Array.isArray(urlOrCommands) ? urlOrCommands : [urlOrCommands];
